export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      isModalOpen: this.value
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (v) {
        this.isModalOpen = v

        if (v && typeof this.modalOpened === 'function') {
          this.modalOpened()
        }
      }
    },
    isModalOpen (s) {
      this.$emit('input', s)
    }
  },
  methods: {
    openModal () {
      this.isModalOpen = true
    },
    closeModal () {
      this.isModalOpen = false
    }
  }
}
